<template src="./template.html"></template>

<script>
import eventBus from 'src/lib/eventBus'

function isString(val) {
  return typeof val === 'string'
}

export default {
  name: 'vue-modals',
  components: {},
  data() {
    return {
      modal: {
        id: null,
        enabled: false,
        visible: false,
        cssId: false,
        inlineComponent: false,
        componentName: null,
        className: null,
        props: null,
      },
    }
  },
  methods: {
    getModalClasses(modal) {
      const modalClasses = {}

      if (modal.cssClass) {
        modalClasses[modal.cssClass] = true
      }

      return modalClasses
    },
    closeModal(data) {
      if (!this.modal) {
        return
      }

      this.modal.visible = false

      setTimeout(() => {
        this.modal.enabled = false

        eventBus.$emit(`hideVueModal-${this.modal.id}`, {
          id: this.modal.id,
          data,
        })
      }, 300) //NOTE: need to delay removing here to allow CSS animation on .slideout to finish
    },
    onShowModal(modal) {
      this.modal.enabled = true
      this.modal.id = modal.id
      this.modal.props = modal.props || {}
      this.modal.cssId = `vue-modal-${this.modal.id}`
      this.modal.inlineComponent = !isString(this.modal.component)
      this.modal.component = modal.component || null
      this.modal.componentName = isString(this.modal.component) ? this.modal.component : this.modal.component.name //tuck away the actual component name
      this.modal.className = modal.className

      this.modal.styles = {}

      setTimeout(() => {
        this.modal.visible = true
      }, 300) //NOTE: need to delay removing here to allow CSS animation on .slideout to finish
    },
    onHideModal() {
      this.closeModal()
    },
    onBgClicked() {
      this.closeModal({
        closedBy: 'bg',
      })
    },
    onCloseBtnClicked() {
      this.closeModal({
        closedBy: 'btn',
      })
    },
    onEscapeKeypress(e) {
      if (e.keyCode === 27) {
        this.closeModal({
          closedBy: 'esc',
        })
      }
    },
  },
  created() {
    document.addEventListener('keydown', this.onEscapeKeypress)
    eventBus.$on('showVueModal', this.onShowModal)
    eventBus.$on('hideVueModal', this.onHideModal)
  },
  destroyed() {
    document.removeEventListener('keydown', this.onEscapeKeypress)
    eventBus.$off('showVueModal', this.onShowModal)
    eventBus.$off('hideVueModal', this.onHideModal)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/VueModals/index.vue